module.exports = __webpack_public_path__ + "static/media/steering-wheel.af07e815.png";